// extracted by mini-css-extract-plugin
export default {"component":"component__QYxy1","title":"title__kG4jF","ctaButton":"ctaButton__dEy90","arrow":"arrow__K7CSp","link":"link__vqFc_","listItem":"listItem__iIF78"};